/* ============================================================
   THE UNLUCKY CASS — Comportamento do card de produto

   Duas funções, ambas opcionais e não essenciais à leitura:
     1. Favoritar  — persiste em localStorage, sempre em try/catch
     2. Adição rápida — intercepta o form nativo e usa o carrinho do tema

   Sem JS: o card continua navegável e o formulário de adição faz
   POST nativo para /cart/add, levando para a página do carrinho.
   ============================================================ */

(function () {
  'use strict';

  var FAV_KEY = 'uc-favorites';

  /* ---------- Favoritos ------------------------------------ */

  // localStorage quebra em navegação anônima e com cookies bloqueados.
  // Toda leitura e escrita é protegida: falhar aqui nunca derruba a página.
  function readFavorites() {
    try {
      var raw = window.localStorage.getItem(FAV_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function writeFavorites(list) {
    try {
      window.localStorage.setItem(FAV_KEY, JSON.stringify(list));
      return true;
    } catch (e) {
      return false;
    }
  }

  function paintFavorites() {
    var favorites = readFavorites();
    document.querySelectorAll('[data-uc-fav]').forEach(function (btn) {
      var id = btn.dataset.ucFav;
      btn.setAttribute('aria-pressed', favorites.indexOf(id) !== -1 ? 'true' : 'false');
    });
  }

  function toggleFavorite(btn) {
    var id = btn.dataset.ucFav;
    var favorites = readFavorites();
    var at = favorites.indexOf(id);

    if (at === -1) {
      favorites.push(id);
    } else {
      favorites.splice(at, 1);
    }

    writeFavorites(favorites);
    btn.setAttribute('aria-pressed', at === -1 ? 'true' : 'false');

    document.dispatchEvent(
      new CustomEvent('uc:favorites:change', { detail: { favorites: favorites } })
    );
  }

  /* ---------- Adição rápida -------------------------------- */

  function cartElement() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function closeAllPickers(except) {
    document.querySelectorAll('[data-uc-pcard].is-picking').forEach(function (card) {
      if (card === except) return;
      card.classList.remove('is-picking');
      var toggle = card.querySelector('[data-uc-quick-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  }

  function showError(form, message) {
    var box = form.querySelector('.uc-pcard__error');
    if (!box) {
      box = document.createElement('p');
      box.className = 'uc-pcard__error';
      box.setAttribute('role', 'alert');
      form.appendChild(box);
    }
    box.textContent = message;
  }

  function clearError(form) {
    var box = form.querySelector('.uc-pcard__error');
    if (box) box.remove();
  }

  function submitQuickAdd(form, button) {
    var card = form.closest('[data-uc-pcard]');
    var cart = cartElement();

    clearError(form);
    button.classList.add('is-loading');
    button.disabled = true;

    var formData = new FormData(form);
    // O botão clicado carrega o id da variante e não entra no FormData sozinho.
    if (button.name && button.value) formData.set(button.name, button.value);

    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map(function (section) {
          return section.id;
        })
      );
      formData.append('sections_url', window.location.pathname);
    }

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

    fetch(addUrl, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        // Shopify devolve `status` só quando deu erro (ex.: sem estoque).
        if (data.status) {
          showError(form, data.description || data.message || 'Não foi possível adicionar.');
          return;
        }

        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(data);
        } else {
          // Sem carrinho na página: cai para o fluxo padrão.
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }

        if (card) card.classList.remove('is-picking');
        closeAllPickers();
      })
      .catch(function () {
        showError(form, 'Falha de conexão. Tente de novo.');
      })
      .finally(function () {
        button.classList.remove('is-loading');
        button.disabled = false;
      });
  }

  /* ---------- Delegação de eventos -------------------------- */

  function onClick(event) {
    var fav = event.target.closest('[data-uc-fav]');
    if (fav) {
      event.preventDefault();
      toggleFavorite(fav);
      return;
    }

    var toggle = event.target.closest('[data-uc-quick-toggle]');
    if (toggle) {
      event.preventDefault();
      var card = toggle.closest('[data-uc-pcard]');
      if (!card) return;
      var opening = !card.classList.contains('is-picking');
      closeAllPickers(card);
      card.classList.toggle('is-picking', opening);
      toggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
      return;
    }

    // Clique fora de qualquer card fecha os seletores abertos.
    if (!event.target.closest('[data-uc-pcard]')) closeAllPickers();
  }

  function onSubmit(event) {
    var form = event.target.closest('[data-uc-quick-form]');
    if (!form) return;

    var button = event.submitter || form.querySelector('button[type="submit"]:focus');
    if (!button || !button.value) return; // sem variante definida: deixa o POST nativo seguir

    event.preventDefault();
    submitQuickAdd(form, button);
  }

  function onKeydown(event) {
    if (event.key === 'Escape') closeAllPickers();
  }

  function init() {
    paintFavorites();

    if (!document.body.dataset.ucCardBound) {
      document.body.dataset.ucCardBound = '1';
      document.addEventListener('click', onClick);
      document.addEventListener('submit', onSubmit);
      document.addEventListener('keydown', onKeydown);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('pageshow', paintFavorites);
  document.addEventListener('shopify:section:load', paintFavorites);
})();
